import * as Sentry from "@sentry/nextjs";
import { ScopeContext } from "@sentry/types";

export type ErrorContext = Partial<ScopeContext>;

export function logError(error: unknown, context?: ErrorContext) {
  console.error(error);
  Sentry.captureException(error, context);
}
